'use client';

import { useEffect } from 'react';
import { useFontSizeStore } from '@fe-news/context/font-size-zustand';

// 初始化字體大小
const FontSizeInitializer = () => {
  const initializeFontSize = useFontSizeStore(state => state.initializeFontSize);

  useEffect(() => {
    initializeFontSize();
  }, [initializeFontSize]);

  // 不需要渲染任何內容
  return null;
};

export default FontSizeInitializer;
